export default { id: '', subIndustries: [''] };
